import { createContext, useContext, useState, useCallback } from 'react';

const BreadcrumbContext = createContext();

export const BreadcrumbProvider = ({ children }) => {
  const [items, setItems] = useState([]);

  const setBreadcrumb = useCallback((newItems) => setItems(newItems), []);
  const clearBreadcrumb = useCallback(() => setItems([]), []);

  return (
    <BreadcrumbContext.Provider value={{ items, setBreadcrumb, clearBreadcrumb }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumb = () => useContext(BreadcrumbContext);
